import React from 'react';
import { Form } from "react-bootstrap";
import axios from 'axios';

export default class LevelList extends React.Component {
    constructor(props) {
        super(props);
        this.state = { datas: null };        
    }

    componentDidMount() {
        let data = { };
        axios.post(`${process.env.REACT_APP_ENDPOINT}/masterregis/level`, data, {
            headers: {
                'Content-Type': 'application/json',
                'authtoken': `${process.env.REACT_APP_AUTH_KEY}`
            }
        })
        .then(resp => { 
            const { data, return_code, return_message } = resp.data
            if (return_code === '0000') {
                this.setState({ datas: data});
            } else {
                console.log(return_message);
            }
        });
    }

    render() {
        const { datas } = this.state;

        if (datas != null) {
            let items = datas.map((data) => 
                <option key={data.level_id} value={data.level_id}>{data.level_name}</option>
            );
            return (
                <Form.Select id={this.props.id} className={this.props.className}>
                    {items}
                </Form.Select>
            )
        } else {
            return (
                <div className='loading'>Loading</div>
            )
        }
    }

}